export default defineNuxtPlugin(() => {
  const router = useRouter()
  let firstRoute = true

  router.afterEach(to => {
    if (firstRoute) {
      firstRoute = false
      return
    }
    window._paq = window._paq || []
    window._paq.push(['setCustomUrl', to.fullPath])
    window._paq.push(['setDocumentTitle', document.title])
    window._paq.push(['trackPageView'])
  })
})
